"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Anushavan.Hovsepyan
 * on 9/19/2016.
 */
var core_1 = require("@angular/core");
var range_control_type_model_1 = require("./range-control-type.model");
require("./sis-range.component.css");
var Range = /** @class */ (function () {
    function Range() {
        /**
         * Acceptable types for Range control.
         * @type {RangeControlType}
         */
        this.rangeControlTypes = range_control_type_model_1.RangeControlType;
        this.disabled = false;
        /**
         * Minimum of acceptable values.
         * @type {any}
         */
        this.minValue = null;
        /**
         * Maximum of acceptable values.
         * @type {any}
         */
        this.maxValue = null;
        /**
         * Start of range.
         * @type {any}
         * @public
         */
        this.startValue = null;
        /**
         * End of range.
         * @type {any}
         * @public
         */
        this.endValue = null;
        /**
         * Property for output selected fields values.
         * @type {any}
         */
        this.onChange = new core_1.EventEmitter();
        /**
         * Inputs are true or not.
         * @type {boolean}
         * @public
         */
        this.isValid = true;
        /**
         * Validation message, which will be shown in wrong inputs.
         * @type {string}
         * @public
         */
        this.validationMessage = "";
    }
    Range_1 = Range;
    /**
     * After initializing values validates types of range.
     */
    Range.prototype.ngAfterContentInit = function () {
        switch (this.rangeControlType) {
            case this.rangeControlTypes.NUMBER: {
                if (!this.isValuesFromNumberType([this.minValue, this.maxValue])) {
                    throw TypeError("Range values must be number.");
                }
                break;
            }
            case this.rangeControlTypes.DATE: {
                if (!this.isValuesInstanceOfDate([this.minValue, this.maxValue])) {
                    throw TypeError("Range values must be Date.");
                }
                break;
            }
            default: {
                throw TypeError("Wrong range control type.");
            }
        }
    };
    /**
     * Checks minValue and maxValue types number or not.
     * values {Array<any>} - values which must checks.
     * @returns {boolean}
     */
    Range.prototype.isValuesFromNumberType = function (values) {
        return values.every(function (value) {
            return (value !== undefined && !isNaN(value) && typeof value === "number");
        });
    };
    /**
     * Checks minValue and maxValue are instance of Date or not.
     * values {Array<any>} - values which must checks.
     * @returns {boolean}
     */
    Range.prototype.isValuesInstanceOfDate = function (values) {
        return values.every(function (value) {
            return (value !== undefined && value instanceof Date);
        });
    };
    /**
     * On start value change calls value change action.
     */
    Range.prototype.onStartValueChange = function () {
        this.onValueChange(Range_1.START_VALUE_FIELD_ID);
    };
    /**
     * On end value change calls value change action.
     */
    Range.prototype.onEndValueChange = function () {
        this.onValueChange(Range_1.END_VALUE_FIELD_ID);
    };
    /**
     * On value change validates values, sets warning message.
     * If inputs are true, outputs selected values.
     * @param {number} fieldId - Field id, which was changed.
     */
    Range.prototype.onValueChange = function (fieldId) {
        if (this.rangeControlType === this.rangeControlTypes.DATE) {
            this.minValue && this.minValue.setHours(0, 0, 0, 0);
            this.maxValue && this.maxValue.setHours(0, 0, 0, 0);
        }
        this.onChange.emit({
            startValue: this.startValue,
            endValue: this.endValue,
            fieldId: fieldId,
        });
    };
    Range.START_VALUE_FIELD_ID = 1;
    Range.END_VALUE_FIELD_ID = 2;
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Range.prototype, "messages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Range.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Range.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], Range.prototype, "rangeControlType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Range.prototype, "minValue", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Range.prototype, "maxValue", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Range.prototype, "startValue", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Range.prototype, "endValue", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], Range.prototype, "onChange", void 0);
    Range = Range_1 = __decorate([
        core_1.Component({
            
            selector: "sis-range",
            template: require('./sis-range.component.html'),
        })
        /**
         * @deprecated use 2 separate number inputs or datepickers instead.
         * Range control.
         * Gets range of values, start and end values,
         * validates inputs and output them.
         * Inputs type must be number or date.
         */
        ,
        __metadata("design:paramtypes", [])
    ], Range);
    return Range;
    var Range_1;
}());
exports.Range = Range;
//# sourceMappingURL=sis-range.component.js.map